import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from './Hero';
import TrustPositioning from './TrustPositioning';
import Solutions from './Solutions';
import Services from './Services';
import WhyKodebuild from './WhyKodebuild';
import Process from './Process';
import Clients from './Clients';
import Contact from './Contact';
import ScrollReveal from './ScrollReveal';

const Home = () => {
    return (
        <>
            <Helmet>
                <title>Kodebuild | #1 Software Engineering &amp; Custom Software Zimbabwe</title>
                <meta name="description" content="Kodebuild is a leading software engineering company specialising in custom web development, mobile applications, AI automation, and cybersecurity. We build high-performance digital products to scale your business." />
                <meta name="keywords" content="software engineering Zimbabwe, custom software development Africa, web development, mobile app development, AI automation, cybersecurity, Kodebuild" />
                <link rel="canonical" href="https://kodebuildtech.com" />
                {/* Open Graph */}
                <meta property="og:title" content="Kodebuild | #1 Software Engineering & Custom Software Zimbabwe" />
                <meta property="og:description" content="We build high-performance digital products — from custom web apps and mobile solutions to AI automation and cybersecurity. Partner with Kodebuild to scale your business." />
                <meta property="og:url" content="https://kodebuildtech.com" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://kodebuildtech.com/Logo/kodebuild_png.png" />
                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Kodebuild | #1 Software Engineering & Custom Software Zimbabwe" />
                <meta name="twitter:description" content="Premium software engineering and custom digital solutions — built by Kodebuild." />
                <meta name="twitter:image" content="https://kodebuildtech.com/Logo/kodebuild_png.png" />
                {/* Structured Data: WebSite */}
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "WebSite",
                      "name": "Kodebuild",
                      "alternateName": "Kodebuild Tech",
                      "url": "https://kodebuildtech.com",
                      "description": "Premium software engineering and custom digital solutions for businesses across Africa and beyond."
                    }
                    `}
                </script>
                {/* Structured Data: Organization + LocalBusiness */}
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": ["Organization", "LocalBusiness"],
                      "name": "Kodebuild",
                      "alternateName": "Kodebuild Tech",
                      "url": "https://kodebuildtech.com",
                      "logo": "https://kodebuildtech.com/Logo/kodebuild_png.png",
                      "image": "https://kodebuildtech.com/Logo/kodebuild_png.png",
                      "description": "Kodebuild is a leading software engineering company specialising in custom web development, mobile applications, AI automation, and cybersecurity.",
                      "foundingDate": "2024",
                      "email": "info@kodebuildtech.com",
                      "telephone": "+263777305046",
                      "address": {
                        "@type": "PostalAddress",
                        "addressLocality": "Harare",
                        "addressCountry": "ZW"
                      },
                      "areaServed": [
                        { "@type": "Country", "name": "Zimbabwe" },
                        { "@type": "Country", "name": "South Africa" },
                        { "@type": "AdministrativeArea", "name": "Africa" }
                      ],
                      "sameAs": [
                        "https://www.linkedin.com/company/kodebuildtech/",
                        "https://www.facebook.com/profile.php?id=61564288034490",
                        "https://www.instagram.com/kodebuild"
                      ],
                      "contactPoint": {
                        "@type": "ContactPoint",
                        "telephone": "+263777305046",
                        "contactType": "customer service",
                        "email": "info@kodebuildtech.com",
                        "availableLanguage": "English"
                      }
                    }
                    `}
                </script>
            </Helmet>

            {/* 1. Hero — first impression */}
            <Hero />

            {/* 2. Trust Positioning */}
            <ScrollReveal>
                <TrustPositioning />
            </ScrollReveal>

            {/* 3. Services / Capabilities */}
            <ScrollReveal delay={0.2}>
                <Services />
            </ScrollReveal>

            {/* 4. Solutions */}
            <ScrollReveal>
                <Solutions />
            </ScrollReveal>

            {/* 5. Why Kodebuild */}
            <ScrollReveal>
                <WhyKodebuild />
            </ScrollReveal>

            {/* 6. Process — how we work */}
            <ScrollReveal>
                <Process />
            </ScrollReveal>

            {/* 7. Clients — logo trust bar */}
            <ScrollReveal>
                <Clients />
            </ScrollReveal>

            {/* 9. Contact — conversion */}
            <ScrollReveal>
                <Contact />
            </ScrollReveal>
        </>
    );
};

export default Home;
